import { logger } from 'logger';

export const logHydrationError = (error: Error, loggerName: 'page' | 'fragment') => {
  logger.error(
    Object.assign(error, {
      logger: `ContentRenderer | ${loggerName}`,
      section: 'Hydration Error',
    }),
  );
};
